import { createContext } from 'react';
import { ArteAiContextData } from './interfaces/arte-ai-context-props.interface';

const ArteAiContext = createContext<ArteAiContextData>({} as ArteAiContextData);

export default ArteAiContext;
